import { render, staticRenderFns } from "./AppSimpleLink.vue?vue&type=template&id=1a32f576"
import script from "./AppSimpleLink.vue?vue&type=script&lang=ts"
export * from "./AppSimpleLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports